let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dfLRJ")).then(() => parcelRequire('1PcVf'));